<template>
    <div class="templete_box">
        <div class="templete">
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="dialog=!dialog;typeChage=2;isMoreSelect=true;">新增</el-button>
                <el-button class="funcPublicBtn" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" @click="batchDel">批量删除</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <!-- <div class="pageBox">
                <pagination :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div> -->
        </div>
        <!--添加修改 START-->
        <el-dialog v-dialog-drag :visible.sync="dialog" class="eldialog eldialogLine" :modal="false" title="新增" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="addObj" class="clearfix dialogFormB">
                    <el-form-item  label="品名：" prop="breed_id">
                        <el-select v-model="addObj.breed_id" placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                            <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="等级：" prop="grade_id">
                        <el-select v-model="addObj.grade_id" placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                            <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="厚度：" prop="original_thickness">
                        <el-select v-model="addObj.original_thickness" placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                            <el-option v-for="list in selectMapC.original_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                        <!-- <el-input v-model="addObj.original_thickness"></el-input> -->
                    </el-form-item>
                    <el-form-item  label="长度：" prop="original_length">
                        <el-select v-model="addObj.original_length" placeholder="长度" :multiple="isMoreSelect" collapse-tags @visible-change="getSelectWarehouseList('original_length')">
                            <el-option v-for="list in selectMapC.original_length" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                        <!-- <el-input v-model="addObj.original_length"></el-input> -->
                    </el-form-item>
                    <el-form-item  label="最低库存量：" prop="min_stocks">
                        <el-input v-model="addObj.min_stocks"></el-input>
                    </el-form-item>
                    <el-form-item  label="最高库存量：" prop="max_stocks">
                        <el-input v-model="addObj.max_stocks"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="dialog=!dialog" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="save">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加修改 END-->
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    // import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                params:{
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                dialog:false,
                isMoreSelect:false,
                addObj:{
                    id:"",
                    breed_id:"",
                    grade_id:"",
                    original_thickness:"",
                    original_length:"",
                    min_stocks:"",
                    max_stocks:""
                },
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                list:[],
                tableCol:[
                    {colName:"品名",colKey:"breed",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"original_length",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"最低库存量",colKey:"min_stocks",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"最高库存量",colKey:"max_stocks",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"当前库存量",colKey:"total_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                totalObj:{},
                typeChage:2 //2新增  //3修改
            }
        },
        created(){
            this.getSelectWarehouseList("breed_id")
            this.getSelectWarehouseList("grade_id")
            this.getList()
        },
        methods:{
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.addObj).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isEdit){
                            arr.push(this.selectRow[i].id)
                        }else{
                            this.tip("请选择数据有不可修改","warning")
                            return;
                        }
                    }
                    this.typeChage=3;
                    this.dialog = true;
                    this.addObj.id = arr;
                    this.isMoreSelect = false;
                }
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        arr.push(this.selectRow[i].id)
                        // if(this.selectRow[i].isDelete){
                        // }else{
                        //     this.tip("请选择数据有不可删除项","warning")
                        //     return;
                        // }
                    }
                    this.del(arr)
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/stock.alert.delete",{id:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            save(){
                let url = "";
                if(this.typeChage==2){
                    url = "/erp/stock.alert.create";
                }else{
                    url = "/erp/stock.alert.update";
                }
                this.postFunc(url,this.addObj,()=>{
                    this.tip('操作成功','success');
                    this.dialog = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params={search:{start_time:"",end_time:"",customer_id:"",sn:"",brand_id:"",breed_id:"",bale_no:"",warehouse_id:"",status:"",},page:1,per_page:50}
                this.getList();
            },
            getList(){
                this.postFunc("/erp/stock.alert.list",this.params,res=>{
                    // this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    // this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach(item=>{
                        item.isEdit = true;
                        item.isDelete = true;
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getTableDelete(id){
                this.del([id])
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.addObj = JSON.parse(JSON.stringify(item))
                        this.dialog = true;
                        this.typeChage = 3;
                        this.addObj.id = [item.id]
                        this.isMoreSelect = false;
                    }
                })
            },
            rowClick(obj){
                this.postFunc("/erp/return.detail",{id:obj.id},res=>{
                    this.form_params=res.data.data;
                    this.form_params.details.forEach((item,index) => {
                        this.form_params.details[index].return_cube=this.keepLimit(this.form_params.details[index].return_cube)
                        this.form_params.details[index].sales_cube=this.keepLimit(this.form_params.details[index].sales_cube)
                        this.form_params.details[index].out_cube=this.keepLimit(this.form_params.details[index].out_cube)
                        this.form_params.details[index].sales_price=this.keepPrice(this.form_params.details[index].sales_price)
                        this.form_params.details[index].totalPrice=this.keepPrice(Number(this.form_params.details[index].sales_price)*Number(this.form_params.details[index].sales_cube))
                    });
                    this.dialogVisible=true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
        },
        components:{
            tabletem,
            // pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialog":function(val){
                if(!val){
                    this.addObj=this.resetJson(this.addObj)
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}
</style>
